var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0",attrs:{"black":"","fluid":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":_vm.getImg(_vm.logo),"contain":"","max-width":"150","height":"50"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }